export default __webpack_public_path__ + "static/thumbnail_madrid-c59cca39f34879e4461cd9a767903cf7.jpg";